let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7crGt")).then(() => parcelRequire('fcXuk'));